import {
  IdealistDayEvent as ApiIdealistDayEvent,
  deleteEvent as apiDeleteEvent,
  fetchEvent as apiFetchEvent,
  hideEvent as apiHideEvent,
  publishEvent as apiPublishEvent,
  unhideEvent as apiUnhideEvent,
} from 'api/orgAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { pushFlashMessage } from '../flashMessages';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { clearResults } from '../mainSearch';

// Types

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, IdealistDayEvent>;
};

type FetchEventRequestAction = {
  type: 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST';
  eventId: string;
};
type FetchEventSuccessAction = {
  type: 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS';
  orgId: string;
  event: ApiIdealistDayEvent;
};
export type Action = FetchEventRequestAction | FetchEventSuccessAction;

// Reducer

export default function idealistDayEventsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      const { event } = action;
      const newState = {
        ...state,
        byId: {
          ...state.byId,
          [event.id]: { ...action.event, isFetching: false },
        },
      };
      return newState;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchEventRequest = (eventId: string): FetchEventRequestAction => ({
  type: 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST',
  eventId,
});

const fetchEventSuccess = (
  orgId: string,
  event: ApiIdealistDayEvent
): FetchEventSuccessAction => ({
  type: 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS',
  orgId,
  event,
});

export const fetchEvent =
  ({
    eventId,
    orgId,
    force,
  }: {
    eventId: string;
    orgId: string;
    force?: boolean;
  }) =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line consistent-return
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const event = state.orgDashboard.idealistDayEvents.byId[eventId];

    if (!event || force) {
      dispatch(fetchEventRequest(eventId));
      return apiFetchEvent(orgId, eventId)
        .then((fetchedEvent) => {
          dispatch(fetchEventSuccess(orgId, fetchedEvent));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const updateEvent = fetchEventSuccess;
export const hideEvent =
  (eventId: string, orgId: string) => (dispatch: Dispatch) =>
    apiHideEvent(orgId, eventId)
      .then((event) => {
        dispatch(updateEvent(orgId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'LISTING_HIDDEN',
          })
        );
      })
      .catch(setError);
export const unhideEvent =
  (eventId: string, orgId: string) => (dispatch: Dispatch) =>
    apiUnhideEvent(orgId, eventId)
      .then((event) => {
        dispatch(updateEvent(orgId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'LISTING_UNHIDDEN',
          })
        );
      })
      .catch(setError);
export const publishEvent =
  (eventId: string, orgId: string) => (dispatch: Dispatch) =>
    apiPublishEvent(orgId, eventId)
      .then((event) => {
        dispatch(updateEvent(orgId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'EVENT_PUBLISHED',
          })
        );
        return event;
      })
      .catch(setError);
export const deleteEvent =
  (eventId: string, orgId: string) => (dispatch: Dispatch) =>
    apiDeleteEvent(orgId, eventId)
      .then((deletedEvent) => {
        dispatch(updateEvent(orgId, deletedEvent));
        dispatch(clearResults());
      })
      .catch(setError);
